// Auth0 constants with no window dependency, safe to import from both
// browser code and Node.js contexts (e.g. cypress.config.ts).
export const AUTH0_PROVIDER_SCOPE = 'read:current_user update:current_user_metadata';
export const AUTH0_USE_REFRESH_TOKENS = true;
export const AUTH0_NON_PROD_CLIENT_ID = 'VJxmlgnmykt2s3SDcJsIdtneGLBZXpAg';
export const AUTH0_NON_PROD_DOMAIN = 'oath-users.us.auth0.com';
